// Address book Label field behavior.
//
// A predefined dropdown drives the hidden free-text `label` input:
//   - "Custom"  -> reveal the text input for manual entry
//   - any other -> fill the input with the option's value (or '' for the blank
//                  option) and hide it, so the chosen text is what gets saved
//
// The server renders the correct initial state, so this only handles changes.

const CUSTOM_OPTION = 'Custom';

function wireLabelField(field) {
  const select = field.querySelector('[data-label-select]');
  const customWrap = field.querySelector('[data-label-custom-wrap]');
  const customInput = field.querySelector('[data-label-custom-input]');

  if (!select || !customWrap || !customInput) return;

  select.addEventListener('change', () => {
    if (select.value === CUSTOM_OPTION) {
      customInput.value = ''; // start blank so a prior label isn't carried over
      customWrap.hidden = false;
      customInput.focus();
    } else {
      customInput.value = select.value; // '' for the blank option
      customWrap.hidden = true;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-label-field]').forEach(wireLabelField);
});
